import plainAxios from "./plainAxios";

const apiClientWithoutInterceptors = {
  get: (url, config = {}) => plainAxios.get(url, config),
  post: (url, data, config = {}) => plainAxios.post(url, data, config),
  patch: (url, data, config = {}) => plainAxios.patch(url, data, config),
  put: (url, data, config = {}) => plainAxios.put(url, data, config),
  delete: (url, config = {}) => plainAxios.delete(url, config),
};
export default apiClientWithoutInterceptors;
